<template>
  <Entity :type="type" class="pdg-">
    <template slot="title">
      <div v-html="highlight(name)" />
    </template>

    <template slot="actions">
      <CallButton :id="username" @call-started="handleCallRequested" />
    </template>
  </Entity>
</template>

<script>
import { mapMutations } from 'vuex';

import Entity from '@/components/ui/Entity';
import CallButton from '@/components/voip/CallButton';

export default {
  components: {
    Entity,
    CallButton,
  },

  props: {
    type: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    username: {
      type: String,
      required: true,
    },
    query: {
      type: String,
      required: true,
    },
  },

  methods: {
    ...mapMutations('ui', ['setSearchResultsPanelVisibility']),

    handleCallRequested() {
      this.setSearchResultsPanelVisibility(false);
    },

    highlight(text) {
      if (!this.query) return text;
      let array = text.split(' ');

      array.forEach((part, i) => {
        array[i] = part.replace(new RegExp(`^${this.query}`, 'gi'), match => {
          return `<mark>${match}</mark>`;
        });
      });

      return array.join(' ');
    },
  },
};
</script>
